import { useTranslation } from 'react-i18next';

/**
 * UI for rendering the VectorStringSource field on the CVE details page's title card.
 */
export const VectorStringSource = ({
  vectorStringSource,
}: {
  vectorStringSource?: string;
}) => {
  const [t] = useTranslation(['vulnerability']);

  if (
    vectorStringSource === undefined ||
    vectorStringSource === null ||
    vectorStringSource?.length < 1
  ) {
    return null;
  }

  const parentLabel = t('vectorStringSource', {
    defaultValue: 'CVSS Source',
    ns: 'vulnerability',
  });

  return (
    <dl>
      <dt>{parentLabel}</dt> <dd>{vectorStringSource}</dd>
    </dl>
  );
};
